// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContactUs_contactContainer__gyYk8 {
  max-width: 700px;
  margin: 0 auto;
  padding: 2rem;
  background-color: #f7f7ff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.ContactUs_heading__EL\\+80 {
  text-align: center;
  font-size: 2rem;
  margin-bottom: 2rem;
  color: #4a4a8f;
}

.ContactUs_infoSection__bg0BU {
  margin-bottom: 2rem;
}

.ContactUs_infoSection__bg0BU h3 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.2rem;
  color: #333366;
  margin-bottom: 0.5rem;
}

.ContactUs_contactItem__Jq-D1 {
  margin: 0.3rem 0;
  color: #555;
}

.ContactUs_socialLink__MkkvI {
  color: #4a4a8f;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s;
}

.ContactUs_socialLink__MkkvI:hover {
  color: #1a1aff;
  text-decoration: underline;
}

.ContactUs_contactForm__ZPzzN {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.ContactUs_contactForm__ZPzzN label {
  display: flex;
  flex-direction: column;
  font-weight: 500;
  color: #333;
}

.ContactUs_contactForm__ZPzzN input,
.ContactUs_contactForm__ZPzzN textarea {
  margin-top: 0.3rem;
  padding: 0.5rem 0.7rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1rem;
  resize: vertical;
}

.ContactUs_contactForm__ZPzzN textarea {
  min-height: 100px;
}

.ContactUs_submitButton__jjMkw {
  padding: 0.7rem 1.2rem;
  background-color: #4a4a8f;
  color: white;
  font-weight: 600;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.ContactUs_submitButton__jjMkw:hover {
  background-color: #1a1aff;
}
`, "",{"version":3,"sources":["webpack://./src/Component/ContactUs.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".contactContainer {\n  max-width: 700px;\n  margin: 0 auto;\n  padding: 2rem;\n  background-color: #f7f7ff;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.heading {\n  text-align: center;\n  font-size: 2rem;\n  margin-bottom: 2rem;\n  color: #4a4a8f;\n}\n\n.infoSection {\n  margin-bottom: 2rem;\n}\n\n.infoSection h3 {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1.2rem;\n  color: #333366;\n  margin-bottom: 0.5rem;\n}\n\n.contactItem {\n  margin: 0.3rem 0;\n  color: #555;\n}\n\n.socialLink {\n  color: #4a4a8f;\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.3s;\n}\n\n.socialLink:hover {\n  color: #1a1aff;\n  text-decoration: underline;\n}\n\n.contactForm {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.contactForm label {\n  display: flex;\n  flex-direction: column;\n  font-weight: 500;\n  color: #333;\n}\n\n.contactForm input,\n.contactForm textarea {\n  margin-top: 0.3rem;\n  padding: 0.5rem 0.7rem;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 1rem;\n  resize: vertical;\n}\n\n.contactForm textarea {\n  min-height: 100px;\n}\n\n.submitButton {\n  padding: 0.7rem 1.2rem;\n  background-color: #4a4a8f;\n  color: white;\n  font-weight: 600;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.submitButton:hover {\n  background-color: #1a1aff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contactContainer": `ContactUs_contactContainer__gyYk8`,
	"heading": `ContactUs_heading__EL+80`,
	"infoSection": `ContactUs_infoSection__bg0BU`,
	"contactItem": `ContactUs_contactItem__Jq-D1`,
	"socialLink": `ContactUs_socialLink__MkkvI`,
	"contactForm": `ContactUs_contactForm__ZPzzN`,
	"submitButton": `ContactUs_submitButton__jjMkw`
};
export default ___CSS_LOADER_EXPORT___;
